var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H39.0932V34H11V16Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8024 16H23.2908V23.3124H11V26.6873H23.2908V33.9997H26.8024V26.6873H39.0932V23.3124H26.8024V16Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6082 28.1309L39.0946 31.5942V28.1309H32.6082ZM28.1016 28.1309L39.0946 34.0003V32.3406L31.2102 28.1309H28.1016ZM36.1664 34.0003L28.1016 29.6939V34.0003H36.1664Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1016 28.1309L39.0946 34.0003V32.3406L31.2102 28.1309H28.1016Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1016 28.1309L39.0946 34.0003V32.3406L31.2102 28.1309H28.1016Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.957 28.1309L11 30.7776V28.1309H15.957ZM21.993 28.8773V34.0004H12.3987L21.993 28.8773Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8844 28.1309L11 32.3406V34.0003L21.993 28.1309H18.8844Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4864 21.8695L11 18.4061V21.8695H17.4864ZM21.993 21.8695L11 16V17.6597L18.8844 21.8695H21.993ZM13.9282 16L21.993 20.3065V16H13.9282Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.993 21.8695L11 16V17.6597L18.8844 21.8695H21.993Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.993 21.8695L11 16V17.6597L18.8844 21.8695H21.993Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1376 21.8695L39.0946 19.2228V21.8695H34.1376ZM28.1016 21.1231V16H37.6959L28.1016 21.1231Z",
    fill: "#0052B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2102 21.8695L39.0946 17.6597V16L28.1016 21.8695H31.2102Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.370d1eb7cac2f42c78e2c0c43d145d8e.svg";
export { ForwardRef as ReactComponent };